import React from "react";

function DialogDelete({ empDetails, clickDelete, clickClose }) {
  return (
    <div
      className="p-4 rounded"
      style={{ maxWidth: "450px", margin: "auto", textAlign: "center" }}
    >
      <div
        className="d-flex align-items-center mb-3"
        style={{ color: "#d18237" }}
      >
        <div className="bg-light p-2 rounded-circle">
          <i className="bi bi-question-circle fs-4"></i>
        </div>
        <h5 className="fw-bold ms-2">Delete User</h5>
      </div>

      <p className="text-muted">
        Are you sure you want to delete this Job Title?
      </p>

      <div className="border rounded py-2 bg-light fw-bold">
        {/* {empDetails?.employee?.firstName} {empDetails?.employee?.lastName} */}
        {empDetails?.positionTitle}
      </div>

      <div className="d-flex justify-content-center mt-4">
        <button
          className="btn text-white px-4 me-2"
          style={{ backgroundColor: "#d18237" }}
          onClick={() => clickDelete()}
        >
          Confirm
        </button>
        <button
          className="btn px-4"
          onClick={() => clickClose()}
          style={{ backgroundColor: "#bdbdbd" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default DialogDelete;
